import styled from 'styled-components'
import { breakpoints } from '../../constants'
import { BLUE, LIGHTGRAY, PRIMARY_COLOR } from '../../styles/colors.style'
import { isMobile } from '../../helpers'

const StyledPrivateMenu = styled.div`
	padding: 0;
	padding-top: 25px;
	width: 0;
	max-width: 60px;
	transition: none;
	position: fixed;
	right: 0;
	z-index: 2;
	height: calc(100vh - 210px);

	@media screen and (max-width: ${breakpoints.MOBILE}px) and (orientation: landscape) {
		overflow-y: auto;
	}

	@media screen and (min-width: ${breakpoints.MOBILE}px) {
		position: relative;
		border-right: 1px solid ${LIGHTGRAY};
		height: auto;
		min-height: 0;
		min-width: 6rem;
	}

	.title {
		font-size: 22px;
		font-weight: 700;
		position: relative;
		padding-right: 0;
		margin-bottom: 30px;
		display: flex;
		align-items: center;
		justify-content: center;

		.text {
			display: none;
		}

		.open-close-btn {
			display: none;

			@media screen and (min-width: ${breakpoints.MOBILE}px) {
				color: ${PRIMARY_COLOR};
				background: none;
				padding: 10px 10px 10px 0;
				width: auto;
				height: auto;
				top: 0;
				left: 15px;
				right: auto;
				position: absolute;
				transform: none;
				display: block;
			}

			&:hover {
				cursor: pointer;
			}
		}
	}

	.user-info {
		@media screen and (min-width: ${breakpoints.MOBILE}px) {
			display: none;
		}
	}

	&.is-open {
		background: ${BLUE};
		max-width: 80vw;
		padding: ${isMobile() ? '2rem 25px 5rem 1rem' : '5rem 25px 5rem 5rem'};
		width: auto;
		position: 'fixed';
		right: 0;
		transition: all 0.1s ease-in;
		overflow: auto;
		${isMobile() ? 'height: calc(100vh - 110px);' : ''}

		@media screen and (min-width: ${breakpoints.MOBILE}px) {
			padding: 25px 15px 15px 15px;
			max-width: 380px;
			background: #fff;
			position: relative;
			min-width: fit-content;
		}

		.title {
			display: none;

			@media screen and (min-width: ${breakpoints.MOBILE}px) {
				display: block;
				opacity: 1;
				white-space: nowrap;
			}

			.text {
				display: none;

				@media screen and (min-width: ${breakpoints.MOBILE}px) {
					color: ${PRIMARY_COLOR};
					display: inline-block;
					padding: 10px;
					padding-left: 40px;
					opacity: 1;
				}
			}

			.open-close-btn {
				display: none;

				@media screen and (min-width: ${breakpoints.MOBILE}px) {
					display: block;
					position: absolute;
					left: 0;
					right: calc(100% - 30px);
				}
			}
		}

		.links {
			opacity: 1;
			transition: unset;
			max-height: 250px;
			overflow: auto;
			@media screen and (min-width: ${breakpoints.MOBILE}px) {
				max-height: 100%;
				overflow: hidden;
			}
		}

		.user-info {
			color: #fff;
			font-size: 16px;
			padding-bottom: 15px;
			border-bottom: 1px solid ${LIGHTGRAY};
			line-height: 1.5;

			@media screen and (min-width: ${breakpoints.MOBILE}px) {
				display: none;
			}
		}
	}

	li,
	.link {
		text-decoration: none;
		font-size: 17px;
		list-style: none;
		color: #fff;
		display: block;

		@media screen and (min-width: ${breakpoints.MOBILE}px) {
			font-size: 22px;
			color: ${BLUE};
		}
	}

	.link::hover {
		cursor: pointer;
	}

	.links {
		opacity: 0;
		padding-left: 0;

		& > .link {
			margin-left: 0;
		}

		li,
		.link {
			padding: 10px 10px 0 0;
			white-space: nowrap;

			&.active {
				color: #d1d1d1;
				font-weight: 600;
			}

			@media screen and (min-width: ${breakpoints.MOBILE}px) {
				padding: 10px 10px 10px 0;
				&:hover {
					cursor: pointer;
					color: ${PRIMARY_COLOR};
				}

				&.active {
					color: ${PRIMARY_COLOR};
				}
			}
		}

		ul {
			max-height: 0px;
			padding-left: 0;
			transition: all 0.3s ease;
			overflow: hidden;
		}

		.fa {
			transform: all 0.3s ease;
			margin-right: 10px;
		}

		.is-open {
			ul {
				max-height: 1000px;
				padding-left: 20px;
				padding-top: 10px;
			}

			.fa {
				transform: rotate(90deg);
			}
		}

		.sair {
			@media screen and (min-width: ${breakpoints.MOBILE}px) {
				display: none;
			}
		}
	}
`

export default StyledPrivateMenu
